import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { useAuth } from "../../auth/components/AuthInit";
import * as actions from "../redux/CashierSettingAction";
import { ProceedDialog } from "./ProceedDialog";

export const CashierSetting = ({}) => {
  const { auth, saveAuth } = useAuth();
  const [swalProps, setSwalProps] = useState({});
  const [show, setShow] = useState(false);
  const [selagentid, setSelagentid] = useState();
  const [username, setUsername] = useState("");
  const intl = useIntl();
  const dispatch = useDispatch();
  const cashierSettingState = useSelector(
    ({ cashierSetting }) => cashierSetting,
    shallowEqual
  );

  useEffect(() => {
    dispatch(
      actions.fetchCashierSettingUI({
        action: "cshagentui",
      })
    );
  }, []);

  const fetchCashier = () => {
    dispatch(
      actions.fetchCashierAgentLookup({
        action: "cshagentlookup",
        selagusername: username,
      })
    ).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "info",
          title: intl.formatMessage({ id: "alert" }),
          html: `<div>${username} are <b>${
            resp.samemastergroup === "true" ? "same" : "different"
          }</b> user group with you. Proceed to let him take over?</div>`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: intl.formatMessage({ id: "confirm" }),
          denyButtonText: intl.formatMessage({ id: "cancel" }),
          onResolve: () => {
            setSwalProps({});
            setSelagentid(resp.selagentid);
            setShow(true);
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  const removeCashierAgent = () => {
    dispatch(
      actions.removeCashierAgent({
        action: "cshremoveagent",
        selagentid: auth.selagentid,
      })
    ).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "successRemoveCashier" }),
          onResolve: () => {
            if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
              saveAuth({
                ...auth,
                ...resp.cshSwitchConfirm,
                username: resp.cshSwitchConfirm.selusername,
              });
              window.location.reload();
            } else {
              setSwalProps({
                show: true,
                icon: "error",
                title: intl.formatMessage({ id: "error" }),
                text: resp.message,
              });
            }
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <ProceedDialog
        setSwalProps={setSwalProps}
        selagentid={selagentid}
        show={show}
        setShow={setShow}
        isClassic={true}
      />
      <div>
        <h2>{intl.formatMessage({ id: "cashierSetting" })}</h2>
      </div>
      {cashierSettingState.cashierSettingUI ? (
        cashierSettingState.cashierSettingUI.canreset === "true" ? (
          <div className="d-flex align-items-center gap-2 mb-4">
            <input
              type="text"
              className="form-control flex-fill"
              placeholder={intl.formatMessage({ id: "username" })}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchCashier();
                }
              }}
            />
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => fetchCashier()}
            >
              {intl.formatMessage({ id: "search" })}
            </button>
          </div>
        ) : (
          <div
            className="p-3 rounded d-flex flex-column gap-2"
            style={{ backgroundColor: "var(--table-background)" }}
          >
            <div className="d-flex gap-2">
              <div>{intl.formatMessage({ id: "daysLeftToReset" })} : </div>
              <div className="fw-bold">
                {cashierSettingState.cashierSettingUI?.dayslefttoreset}
              </div>
            </div>
            <div className="d-flex gap-2">
              <div>{intl.formatMessage({ id: "careedUsername" })} : </div>
              <div className="fw-bold">
                {cashierSettingState.cashierSettingUI?.becareedusername}
              </div>
            </div>
            <div className="mt-2">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => removeCashierAgent()}
              >
                {intl.formatMessage({ id: "remove" })}
              </button>
            </div>
          </div>
        )
      ) : null}
    </div>
  );
};
